import { Preferences } from '@capacitor/preferences'

export enum StorageKeys {
  LastLoggedInAt = 'lastLoggedIn',
  PreSelectedDoctor = 'preSelectedDoctor',
  EHealthPkceCodeVerifier = 'ehealthPkceCodeVerifier',
}

export const StorageService = {
  getItem: async (key: StorageKeys): Promise<string | null> => {
    try {
      const getResult = await Preferences.get({ key })

      if (!getResult?.value) {
        return null
      }

      return getResult.value
    } catch {
      return null
    }
  },

  setItem: <T>(key: StorageKeys, value: T) => {
    return Preferences.set({ key, value: JSON.stringify(value) })
  },

  removeItem: (key: StorageKeys) => {
    return Preferences.remove({ key })
  },
}
